export default __webpack_public_path__ + "static/media/CheckboxLBIcon.b84e624e.svg";